import { Component } from '@angular/core';
import { NotificationService } from './notification.service';
import { Router } from '@angular/router';
import { NotificationListDetailsService } from '../../core/notification-list-details/notification-list-details.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent {
  currentNotification = 0;
  totalNotifications = 0;
  username: any = ''
  constructor(private notificationService: NotificationService, private router: Router, private notificationDetailsService: NotificationListDetailsService, public dialogRef: MatDialogRef<NotificationComponent>) { }
  ngOnInit() {
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        // this.username = loginResponse.data?.user?.first_name + ' ' + loginResponse.data?.user?.last_name || '';
        let firstName = loginResponse.data.user?.first_name || '';
        let lastName = loginResponse.data.user?.last_name || '';
        this.username = `${firstName} ${lastName}`.trim();
      }
    }
    this.getToDo();
  }

  previous() {
    if (this.currentNotification >= 1) {
      this.currentNotification--;
      this.notificationObject = this.notifications[this.currentNotification]
    }
  }

  next() {
    if (this.currentNotification < this.totalNotifications - 1) {
      this.currentNotification++;
      this.notificationObject = this.notifications[this.currentNotification]
    }
  }

  notifications: any = [];
  notificationObject: any = {};
  isLoading: boolean = false;
  getToDo() {
    this.isLoading = true;
    this.notificationService.getToDo().subscribe((response: any) => {
      let responseData: any = response.body
      if (responseData.responseCode == 200) {
        this.notifications = response.body.data
        this.notifications = this.notifications.filter((data: any) => data.count != 0)
        if (this.notifications.length > 0) {
          this.notificationObject = this.notifications[0];
          this.totalNotifications = this.notifications.length;
          this.currentNotification = 0
        }
        setTimeout(() => {
          this.isLoading = false;
        }, 1200)
      } else {
        this.isLoading = false;
        this.notifications = []
      }
    })
  }


  navigateToDetails(object: any) {
    this.onClose();
    this.router.navigate(['/suzuki/to-do'])
    this.notificationDetailsService.changeData(object.key)
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
